export default "__VITE_ASSET__peGLo2Nk__"